// Image select dialog
window.openImageSelect = function (clb) {
	AUI().use('liferay-item-selector-dialog', (A) => {
		const eventName =
			'_com_liferay_layout_content_page_editor_web_internal_portlet_ContentPageEditorPortlet_selectImage';
		const criteria =
			'%7B%22desiredItemSelectorReturnTypes%22%3A%22com.liferay.item.selector.criteria.URLItemSelectorReturnType%22%7D';

		const itemSelectorDialog = new A.LiferayItemSelectorDialog({
			eventName,
			title: Liferay.Language.get('select-file'),
			url: `${location.origin}/group/guest/~/control_panel/manage/-/select/image/${eventName}
?_com_liferay_item_selector_web_portlet_ItemSelectorPortlet_0_json=${criteria}
&_com_liferay_item_selector_web_portlet_ItemSelectorPortlet_1_json=${criteria}
&p_p_auth=${Liferay.authToken}
&_null_bodyCssClass=cadmin+dialog-iframe-popup`,
		});

		Liferay.detachAll(eventName);

		Liferay.once(eventName, (data) => {
			clb(location.origin + data.data.value);
			itemSelectorDialog.close();
		});

		itemSelectorDialog.open();
	});
};
